import React from 'react';
import { LTS_PAGE_SEO_CONTENT } from '../../constants/SEOConstants';

const SEOContent = () => {
  return (
    <div className="LTSPageCommon-SEOContent-wrapper">
      {LTS_PAGE_SEO_CONTENT.map((pageContent, index) => (
        <div
          className="LTSPageCommon-SEOContent-content"
          key={index}
          dangerouslySetInnerHTML={{ __html: pageContent.description }}
        />
      ))}
    </div>
  );
};

export default SEOContent;
